import React from 'react'

const Checkplates = ({ options }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        border: '1px solid #E2E2FC',
        borderRadius: '4px',
        width: 'fit-content',
      }}
    >
      {options.map((option, index) => (
        <div
          key={index}
          style={{
            fontSize: 14,
            flexDirection: 'row',
            display: 'flex',
            borderRadius:
              options.length === 1
                ? '4px'
                : index === options.length - 1
                ? '0px 4px 4px 0px'
                : index === 0
                ? '4px 0px 0px 4px'
                : 0,
            alignItems: 'center',
            padding: '4px 10px',
            backgroundColor: option.active ? '#1A2547' : 'transparent',
            color: option.active ? 'white' : '#707087',
            cursor: 'pointer',
          }}
          onClick={option.onChange}
        >
          {option.icon(option.active ? 'white' : '#707087')}
          <div
            style={{
              marginLeft: '8px',
              fontSize: 14,
              fontWeight: 400,
              color: option.active ? 'white' : '#707087',
            }}
          >
            {option.label}
          </div>
        </div>
      ))}
    </div>
  )
}

export default Checkplates
